import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { Button, YoutubePlayerComponent } from '@shared/components';

@Component({
  selector: 'app-cost-or-complexity',
  imports: [Button, YoutubePlayerComponent],
  templateUrl: './cost-or-complexity.html',
  styleUrl: './cost-or-complexity.scss',
})
export class CostOrComplexity {
  readonly environment = environment;
}
